import { z } from "zod";

/**
 * Collection-grant schemas — a knowledge Collection reaching a Role.
 */

/**
 * A knowledge Collection's access to a Role — the one exception to
 * RoleResource's exclusive-ownership rule (a Collection can be shared across
 * multiple Roles). Unlike PermissionSetGrantSchema, there is no `surface` — a
 * Collection grant is not scoped to one app surface.
 */
export const RoleCollectionGrantSchema = z.object({
  id: z.string(),
  roleId: z.string(),
  organizationId: z.string(),
  collectionId: z.string(),
  createdAt: z.string()
});

export type RoleCollectionGrant = z.infer<typeof RoleCollectionGrantSchema>;

export const RoleCollectionGrantsListResponseSchema = z.object({
  grants: z.array(RoleCollectionGrantSchema)
});

export const RoleCollectionGrantCreateBodySchema = z.object({
  collectionId: z.string().min(1)
});

export const RoleCollectionGrantPathVarsSchema = z.object({
  id: z.string().uuid(),
  grantId: z.string().uuid()
});

/** Deleting a grant is idempotent — `removed` says whether a row actually went. */
export const RoleCollectionGrantDeleteResponseSchema = z.object({
  removed: z.boolean()
});
